import {Component, ElementRef, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {firstValueFrom, Observable, Subject, timeout} from 'rxjs';
import {map, take, takeUntil} from 'rxjs/operators';
import { CentreOption} from '../../../../interfaces/Centres';
import {CentreService} from '../../../../services/centre.service';
import {ChildService} from '../../../../components/child/child.service';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {MatSelectChange} from "@angular/material/select";
import html2pdf from "html2pdf.js";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {PhotoGalleryComponent} from "../../../../components/photo-gallery/photo-gallery.component";
import {ChartConfiguration, ChartEvent} from 'chart.js';
import {BaseChartDirective} from 'ng2-charts';
import html2canvas from "html2canvas";
export type ChartOptions = ChartConfiguration['options']; // Use the broader type
import { Location } from '@angular/common';
import {LoadingService} from "../../../../services/loading.service";
import { NotificationService } from '../../../../services/notification.service';
import {endOfDay} from '../../../../utils/date-range-format.service';

@Component({
  selector: 'app-impact-report-counseling',
  templateUrl: './impact-report-counseling.component.html',
  styleUrls: ['./impact-report-counseling.component.scss'],
})
export class ImpactReportCounselingComponent implements OnInit, OnDestroy {

  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();

  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;
  @ViewChild('content') content!: ElementRef;
  centre: any
  mStartDate: null | Date = null;
  mEndDate: null | Date = null;
  childDetails: any;
  centres$: Observable<CentreOption[]>;
  showAdmissionChart = false
  individualSessionsControl:any
  groupSessionsControl:any
  totalAssesssmentSessionsControl:any
  selectedCentre!: CentreOption
  selectedCentreName = '';
  impactReport: any;
  problemAddressed = '';
  intervention2: any
  problemAddressed2: any
  counselling = '';
  intervention = '';
  groupCounselling = '';
  mAdmissionsAssessment: any;
  mDischargeAssessment: any;
  mDischargeChartData: number[] = [];
  mAdmissionChartData: number[] = [];
  showDelete=true
  colors: any[] = [{backgroundColor: ['#0b5ba8', '#6114be', '#15dcdc']}];
  reportTypes=["Monthly","Quarter 1","Quarter 2","Quarter 3","Quarter 4","First Half","Second Half","2024-2025","2025-2026"]
  reportType:string|undefined
  smileys = [
    {src: '../../../../../assets/images/smiley/greenSmiley.png', alt: 'green smiley'},
    {src: '../../../../../assets/images/smiley/neutral.png', alt: 'neutral smiley'},
    {src: '../../../../../assets/images/smiley/redEmoji.png', alt: 'sad smiley'}
  ];
  // @ts-ignore

  doughnutChartOptions: ChartConfiguration<'pie'>['options'] = {
    responsive: false,
    plugins: {
      legend: {
        display: true,
        position: 'top'
      },
      // @ts-ignore
      // Add dataLabels plugin configuration
      dataLabels: {
        display: true, // Enable data labels
        formatter: (value: number, context: ChartEvent) => {
          // @ts-ignore
          const label = context.dataset.label || ''; // Get dataset label
          return `${label}: ${value}%`; // Format label with percentage
        },
        fontColor: 'black', // Adjust data label text color
        fontSize: 14, // Adjust data label font size
      }
    },
  };  // doughnutChartLabels: string[] = ['Difficulty in Coping up', 'Sometimes', 'Able to Cope up'];
  doughnutChartLabels: string[] = ['Difficulty in coping', 'Able to Cope up', 'Sometimes'];
  doughnutChartDatasets1?: ChartConfiguration<'pie'>['data']['datasets'];
  apexChartData1: number[] = []
  apexChartData2: any
  doughnutChartDatasets2?: ChartConfiguration<'pie'>['data']['datasets'];
  mAllAssessments: any[] = []
  mAllGroupSessions: any[] = []
  mAllIndividualSessions: any[] = []
  mId: string | undefined
  mData: any;
  sessionCounts!: { groupSessions: number; individualSessions: number; assessmentSessions: number };
  selectedSubmit: 'draft'|'final' ='draft';
  isFormFieldDisabled = false;
  selectedGalleryImages: string[] = []
  showDischargeChart: boolean = false;
  para1=" The Counselling Program of Access Life Assistance Foundation was\n" +
    "          started with the intention that no family should abandon the treatment. “The objective\n" +
    "          of the psychological interventions done at Access Life is focused on assisting the\n" +
    "          family and the child to cope with the stress of the diagnosis, treatment  prognosis of\n" +
    "          the illness while adjusting to living with other families in a new city. Towards this, the\n" +
    "          assessments and interventions are being planned and implemented by our\n" +
    "          psychologists."
  para2= "Admission counselling was conducted for new families to build rapport and assess their needs. Regular counselling sessions and assessments monitored coping progress, while discharge counselling reviewed the family’s overall journey and provided post-treatment guidance. Follow-up sessions offered continued support, tracked progress, and addressed any ongoing emotional and mental well-being concerns."
  endLine: string = "Currently,  families are staying with us. All family’s individual counselling sessions are carried out twice a month and Intermediate Psychological assessments are carried out once every two months to evaluate our course of counseling interventions. Group sessions are held once every month."
  endLine1: string = "With subsequent counseling intervention, monitoring their stress levels and helping them enhance their problem solving and coping and adjustment skills; at the time of Discharge the families reported higher coping skills"

  userData = JSON.parse(localStorage.getItem('userData') || '{}');

  constructor(
    private centreService: CentreService,
    private mFirestore: AngularFirestore,
    private childService: ChildService,
    private location: Location,
    private loader : LoadingService,
    private mSnackbar: MatSnackBar,
    private route: ActivatedRoute,
    private matDialog: MatDialog,
    private notificationService: NotificationService,
    private router : Router
  ) {
    this.centres$ = this.centreService.getAllCentresOptions().pipe(
      map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
    );
  }

  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this._destroyed$)).subscribe(params => {
      this.mId = params['id'];
      if (this.mId) {
        this.loadImpactReport(this.mId);
      }
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  private loadImpactReport(id: string): void {
    this.mFirestore.collection(this.env.counsellingImpactReport).doc(id).valueChanges().pipe(take(1), takeUntil(this._destroyed$)).subscribe((data: any) => {
      if (data) {
        console.log(data)
        console.log(data.problemAddressed)
        this.galleryImages = data.galleryImages || [];
        this.mData = data;
        this.mStartDate = data.from.toDate();
        this.mEndDate = data.to.toDate();
        this.problemAddressed = data.problemAddressed;
        this.counselling = data.counselling;
        this.intervention = data.intervention;
        this.groupCounselling = data.groupCounselling;
        this.para1 = data.para1;
        this.para2 = data.para2;
        this.endLine = data.endLine;
        this.endLine1 = data.endLine1;
        this.reportType = data.reportType|| "Monthly";
        this.mAllIndividualSessions.length = data.sessionCounts.individualSessions;
        this.individualSessionsControl = data.sessionCounts.individualSessions;
        this.mAllGroupSessions.length = data.sessionCounts.groupSessions;
        this.groupSessionsControl = data.sessionCounts.groupSessions;
        this.mAllAssessments.length = data.sessionCounts.assessmentSessions;
        this.totalAssesssmentSessionsControl = data.sessionCounts.assessmentSessions;
        this.selectedCentre = { centreName: data.centreName, centreCode: data.centreCode } as CentreOption;
        this.centre = this.selectedCentre;
        this.updateCentre(data);

        this.selectedSubmit = data.submitType === 'final' ? 'final' : 'draft';
        this.restoreSavedCharts(data);

        // this.searchData();
        // setTimeout(() => this.searchData(), 2000);
      }
    });
  }

  private restoreSavedCharts(data: any): void {
    this.mAdmissionChartData = Array.isArray(data.admissionChartData) ? data.admissionChartData : [];
    this.apexChartData1 = [...this.mAdmissionChartData];
    this.showAdmissionChart = this.mAdmissionChartData.some(v => v > 0);
    this.mDischargeChartData = Array.isArray(data.dischargeChartData) ? data.dischargeChartData : [];
    this.apexChartData2 = [...this.mDischargeChartData];
    this.showDischargeChart = this.mDischargeChartData.some(v => v > 0);
  }

  private sanitizeChartData(values: number[]): number[] {
    return (values || []).map(v => Number.isFinite(v) ? v : 0);
  }

  async searchData() {
    try {
      this.showAdmissionChart =false
      this.showDischargeChart =false
      // Convert observables to promises
      const individualSessionRef = this.mFirestore.collection(`${this.env.counseling}/allSessions/sessions`, ref =>
        ref.where('centreCode', '==', this.selectedCentre.centreCode)
          //.where('type','==','Regular Counselling')
          .where('type', 'in', ['Regular Counselling', 'Follow-up Counselling', 'Extended Counselling'])
          .where('date', '>=', this.mStartDate)
          .where('date', '<=', endOfDay(this.mEndDate))
      ).valueChanges();

      const groupSessionRef = this.mFirestore.collection(`${this.env.counseling}/allSessions/groupSessions`, ref =>
        ref.where('date', '>=', this.mStartDate)
          .where('date', '<=', endOfDay(this.mEndDate))
          .where('centreCode', '==', this.centre.centreCode)
      ).valueChanges();
//newl added logic by sumeet

      const assessmentRef = this.mFirestore.collection(`${this.env.assessment}/allAssessments/assessments`, ref =>
        ref.where('centreCode', '==', this.selectedCentre.centreCode)
          .where('dateOfAssessment', '>=', this.mStartDate)
          .where('dateOfAssessment', '<=', endOfDay(this.mEndDate))
          .where('type', 'in', ['Admission Baseline Assessment', 'Discharge Assessment'])
      ).valueChanges();
      // Fetch all data in parallel using async/await
      const [allIndividualTypeSessions, groupSessions, assessments] = await Promise.all([
        firstValueFrom(individualSessionRef),
        firstValueFrom(groupSessionRef),
        firstValueFrom(assessmentRef)
      ]);

      // Individual count covers Regular, Follow-up and Extended counselling; interventions/problems
      // are still derived from Regular and Follow-up sessions only
      const individualSessions = allIndividualTypeSessions.filter((s: any) => s.type !== 'Extended Counselling');

      // Process Individual Sessions
      this.mAllIndividualSessions = individualSessions;
      this.intervention2 = this.mAllIndividualSessions
        .filter(session => session.interventions !== undefined)
        .map(session => session.interventions);

      const uniqueInterventions = new Set(this.intervention2.flat());
      this.intervention2 = Array.from(uniqueInterventions);
      if (!this.intervention){
        this.intervention = this.intervention2.join('\n');
      }
      this.problemAddressed2 = this.mAllIndividualSessions
        .filter(session => session.challengesFaced !== undefined)
        .map(session => session.challengesFaced);

      const uniqueProblems = new Set(this.problemAddressed2.flat());
      this.problemAddressed2 = Array.from(uniqueProblems);
      if (!this.problemAddressed){
        this.problemAddressed = this.problemAddressed2.join('\n');
      }

      console.log("Unique Problems Addressed:", this.problemAddressed);
      console.log('mAllIndividualSessions', this.mAllIndividualSessions);
      console.log('mAllIndividualSessions', this.intervention2);
      this.individualSessionsControl = allIndividualTypeSessions.length;

      const countByType = (type: string) => allIndividualTypeSessions.filter((x: any) => x.type === type).length;
      console.table([
        { category: 'Individual - Regular Counselling', count: countByType('Regular Counselling') },
        { category: 'Individual - Follow-up Counselling', count: countByType('Follow-up Counselling') },
        { category: 'Individual - Extended Counselling', count: countByType('Extended Counselling') },
        { category: 'Individual Sessions (total)', count: allIndividualTypeSessions.length },
        { category: 'Group Sessions', count: groupSessions.length },
        { category: 'Assessment Sessions (Admission/Discharge)', count: assessments.length },
        {
          category: 'TOTAL SESSIONS',
          count: allIndividualTypeSessions.length + groupSessions.length + assessments.length
        },
      ]);

      // Process Group Sessions
      this.mAllGroupSessions = groupSessions;
      this.groupSessionsControl= groupSessions.length
      console.log('mAllGroupSessions', groupSessions.length);
      console.log('mAllGroupSessionsSorted', this.mAllGroupSessions.length);

      // Process Assessments
      this.mAllAssessments = assessments;
      this.totalAssesssmentSessionsControl = assessments.length
      console.log('mAllAssessments', assessments.length);

      // Initialize chart data
      this.mAdmissionChartData = [];
      this.mDischargeChartData = [];
      this.mAdmissionsAssessment = null;
      this.mDischargeAssessment = null;
      this.doughnutChartDatasets1 = undefined;
      this.doughnutChartDatasets2 = undefined;

      // Fetch additional data for charts
      const dischargeAssessmentPromise = new Promise((resolve, reject) => {
        this.fetchAssessmentData('Discharge Assessment', this.selectedCentre.centreCode, (res: any) => {
          this.mDischargeAssessment = res;
          if (this.mDischargeAssessment != null) {
            this.startDischargeChart();
          }
          resolve(res);
        });
      });

      const admissionAssessmentPromise = new Promise((resolve, reject) => {
        this.fetchAssessmentData('Admission Baseline Assessment', this.selectedCentre.centreCode, (res: any) => {
          this.mAdmissionsAssessment = res;
          if (this.mAdmissionsAssessment != null) {
            this.startAdmissionChart();
          }
          resolve(res);
        });
      });

      // Wait for additional data fetching to complete
      await Promise.all([dischargeAssessmentPromise, admissionAssessmentPromise]);

    } catch (error) {
      console.error("Error fetching data", error);
    }
  }


  fetchAssessmentData(assessmentType: string, selectedCentre: string, callback: Function) {

    if (this.mAllAssessments && this.mAllAssessments.length > 0) {
      let data = this.mAllAssessments.filter((x: any) => x.type == assessmentType)
      console.log(`SORTED BY ${assessmentType}`, data.length)
      callback(data);
    }

  }


  private startDischargeChart() {
    let totalYes = 0
    let totalNo = 0
    let totalSometimes = 0
    this.mDischargeAssessment.forEach((it: any) => {
      totalYes += it.assessment.filter((x: any) => x.ans == 'Yes').length;
      totalNo += it.assessment.filter((x: any) => x.ans == 'No').length;
      totalSometimes += it.assessment.filter((x: any) => x.ans == 'Sometimes').length;

    })
    // // Refactored startDischargeChart() function
    // const totalYes = this.mDischargeAssessment.assessment.filter((x: any) => x.ans == 'Yes').length;
    // const totalNo = this.mDischargeAssessment.assessment.filter((x: any) => x.ans == 'No').length;
    // const totalSometimes = this.mDischargeAssessment.assessment.filter((x: any) => x.ans == 'Sometimes').length;

    const total = totalYes + totalNo + totalSometimes
    const totalYesPercentage = Number(((totalYes / total) * 100).toFixed(2))
    const totalNoPercentage = Number(((totalNo / total) * 100).toFixed(2))
    const totalSometimesPercentage = Number(((totalSometimes / total) * 100).toFixed(2))

    this.mDischargeChartData = [totalYesPercentage, totalNoPercentage, totalSometimesPercentage];

    // this.mDischargeChartData = [totalYes, totalNo, totalSometimes];

    this.apexChartData2 = this.mDischargeChartData
    this.doughnutChartDatasets2 = [
      {data: this.mDischargeChartData, label: 'Discharge:', backgroundColor: ["#ed7d31", "#70ad47", "#FFC000"]},
    ];
    if(this.mDischargeAssessment.length>=1)   this.showDischargeChart = true
// alert(this.mDischargeChartData[0])
// alert(this.mDischargeChartData[1])
// alert(this.mDischargeChartData[2])
  }


  previewImageUrl: string | null = null;
  showPreview: boolean = false;

  openImagePreview(imageUrl: any) {
    this.previewImageUrl = imageUrl;
    this.showPreview = true;
  }

  closeImagePreview() {
    this.showPreview = false;
    this.previewImageUrl = null;
  }

  private startAdmissionChart() {
    let totalYes = 0
    let totalNo = 0
    let totalSometimes = 0
    this.mAdmissionsAssessment.forEach((it: any) => {
      totalYes += it.assessment.filter((x: any) => x.ans == 'Yes').length;
      totalNo += it.assessment.filter((x: any) => x.ans == 'No').length;
      totalSometimes += it.assessment.filter((x: any) => x.ans == 'Sometimes').length;

    })
    console.log('AtotalYes', totalYes)
    console.log('AtotalNo', totalNo)
    console.log('AtotalSometimes', totalSometimes)
    const total = totalYes + totalNo + totalSometimes
    const totalYesPercentage = Number(((totalYes / total) * 100).toFixed(2))
    const totalNoPercentage = Number(((totalNo / total) * 100).toFixed(2))
    const totalSometimesPercentage = Number(((totalSometimes / total) * 100).toFixed(2))
    this.mAdmissionChartData = [totalYesPercentage, totalNoPercentage, totalSometimesPercentage];
    this.apexChartData1 = [totalYesPercentage, totalNoPercentage, totalSometimesPercentage];
    this.doughnutChartDatasets1 = [
      {data: this.mAdmissionChartData, label: 'Admission', backgroundColor: ["#ed7d31", "#70ad47", "#FFC000"]},
    ];
    if(this.mAdmissionsAssessment.length >= 1) this.showAdmissionChart = true
  }

  onCentreSelect($event: MatSelectChange) {
    let c = $event.value as CentreOption
    this.selectedCentre = c
    this.selectedCentreName = c.centreName
    this.centre = {"centreCode": c.centreCode, "centreName": c.centreName}
    // console.log('OncentreSelect', this.centre)
  }

  printDoc() {
    let printContents;
    const previewElement = document.getElementById('previewCounselingReports');
    if (previewElement) {
      printContents = previewElement.innerHTML;
    } else {
      console.error('Element with ID "preview" not found.');
      return; // Exit the function if the element is not found
    }

    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
                    <html>
                        <head>
                            <title>Counselling-Impact-Report</title>
                            <style>
                                 @media print {
                        body{
                        margin: 0;
                        padding: 0;
                        }
                            .page{
                            position: relative;
                            padding: 10px;
                            margin: 10px;
                            box-sizing: border-box;
                            page-break-after: always;
                            }

                            .page:before{
                            content:'';
                            display:block;
                            position:fixed;
                            top:0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            border: 1px solid #000000;
                            box-sizing: border-box;
                            pointer-events: none;
                            z-index: -1;
                            }
                        }
                            </style>
                        </head>
                        <body onload="window.print(); window.close();">
                           <div class="page">
                ${printContents}
                </div>
                        </body>
                    </html>
                `);
      popupWin.document.close();
    } else {
      console.error('Popup window could not be opened.');
    }

  }

  async printDocx() {
    console.log('printing')
    const content = this.content.nativeElement;
    const images = content.querySelectorAll('img');

    try {
      console.log('inside try')
      // Pre-load all images concurrently using Promise.allSettled
      const imageLoadResults = await Promise.allSettled(
        Array.from(images).map((image) => new Promise((resolve, reject) => {
          console.log('inside array')

          // @ts-ignore
          image.onload = resolve;
          // @ts-ignore
          image.onerror = reject;
        }))
      );

      // Check for any image loading errors
      const failedImages = imageLoadResults.filter(result => result.status === 'rejected');
      if (failedImages.length > 0) {
        console.warn('Failed to load some images:', failedImages);
        // Handle errors (e.g., display a message to the user)
        // You can decide if you want to proceed with PDF generation or not
      }

      const options = {
        margin: 10,
        filename: `Counselling-Impact-Report.pdf`,
        image: {type: 'jpeg', quality: 0.90},
        html2canvas: {scale: 1},
        jsPDF: {unit: 'mm', format: 'a4', orientation: 'portrait'},
        pageBreakTrigger: '#pageBreak' // Add page breaks using CSS classes
      };

      // Use html2pdf.js to generate the PDF
      await html2pdf()
        .from(content)
        .set(options)
        .save();
    } catch (error) {
      console.error('Error generating PDF:', error);
      // Handle other errors during PDF generation
    }
  }
  galleryImages: any[] = [];


  // save() {
  //   if(this.selectedCentre && this.mStartDate && this.mEndDate && this.selectedSubmit) {
  //     let obj = {
  //       problemAddressed: this.problemAddressed,
  //       counselling: this.counselling,
  //       intervention: this.intervention,
  //       groupCounselling: this.groupCounselling,
  //       centreCode: this.selectedCentre.centreCode,
  //       centreName: this.selectedCentre.centreName,
  //       para1:this.para1,
  //       para2:this.para2,
  //       endLine:this.endLine,
  //       endLine1:this.endLine1,
  //       from: this.mStartDate,
  //       images:[],
  //       to: this.mEndDate,
  //       createdAt: new Date(),
  //       sessionCounts: {
  //         individualSessions: this.individualSessionsControl,
  //         groupSessions: this.groupSessionsControl,
  //         assessmentSessions: this.totalAssesssmentSessionsControl,
  //       },
  //       submitType: this.selectedSubmit,
  //     };
  //
  //     console.log(obj);
  //
  //
  //     if (this.mId !== undefined) {
  //       this.mFirestore
  //         .collection('CounselingImpactReport')
  //         .doc(this.mId)
  //         .update(obj)
  //         .then(() => {
  //           this.mSnackbar.open('Report Saved Successfully')._dismissAfter(3000);
  //           // this.printDoc();
  //         })
  //         .catch((error) => {
  //           console.error("Error updating document: ", error);
  //         });
  //     } else {
  //       this.mFirestore
  //         .collection('CounselingImpactReport')
  //         .add(obj)
  //         .then(() => {
  //           this.mSnackbar.open('Report Saved Successfully')._dismissAfter(3000);
  //           // this.printDoc();
  //           this.location.back()
  //         })
  //         .catch((error) => {
  //           console.error("Error adding document: ", error);
  //         });
  //     }
  //   } else
  //   {
  //     this.mSnackbar.open('Please check if centre and dates are selected!', "", {
  //       duration: 3000,
  //       panelClass: 'error'
  //     })
  //   }
  //
  // }
  async save(): Promise<void> {
    if (this.selectedCentre && this.mStartDate && this.mEndDate && this.selectedSubmit && this.reportType) {
      this.loader.setLoading(true);
      try {
        const obj: any = {
          problemAddressed: this.problemAddressed,
          counselling: this.counselling,
          intervention: this.intervention,
          groupCounselling: this.groupCounselling,
          centreCode: this.selectedCentre.centreCode,
          centreName: this.selectedCentre.centreName,
          para1: this.para1,
          para2: this.para2,
          endLine: this.endLine,
          endLine1: this.endLine1,
          reportType: this.reportType,
          admissionChartData: this.sanitizeChartData(this.mAdmissionChartData),
          dischargeChartData: this.sanitizeChartData(this.mDischargeChartData),
          from: this.mStartDate,
          galleryImages: this.galleryImages || [],
          to: this.mEndDate,
          sessionCounts: {
            individualSessions: this.individualSessionsControl ?? 0,
            groupSessions: this.groupSessionsControl ?? 0,
            assessmentSessions: this.totalAssesssmentSessionsControl ?? 0,
            totalSessions: this.getGrandTotalSessions(),
          },
          submitType: this.selectedSubmit,
          updatedAt: new Date(),
        };

        if (this.mId !== undefined) {
          await this.mFirestore.collection(this.env.counsellingImpactReport).doc(this.mId).update(obj);
          this.mSnackbar.open('Report Saved Successfully', '', { duration: 3000 });
          this.router.navigateByUrl('/home/reports/impact-report-counseling-table');
        } else {
          obj.createdAt = new Date();
          await this.mFirestore.collection(this.env.counsellingImpactReport).add(obj);
          this.mSnackbar.open('Report Saved Successfully', '', { duration: 3000 });
          this.location.back();
        }
      } catch (error) {
        console.error("Error saving report: ", error);
        this.mSnackbar.open('Error saving report. Please try again.', '', { duration: 3000, panelClass: 'error' });
      } finally {
        this.loader.setLoading(false);
      }
    } else {
      this.mSnackbar.open('Please check if centre and dates are selected!', "", {
        duration: 3000,
        panelClass: 'error'
      });
    }
  }

  /** Individual (Regular, Follow-up, Extended) + Assessment (Admission, Discharge) + Group */
  getGrandTotalSessions(): number {
    return [this.individualSessionsControl, this.totalAssesssmentSessionsControl, this.groupSessionsControl]
      .reduce((sum: number, v: any) => sum + (Number(v) || 0), 0);
  }

  getTotalSessions() {
    return this.individualSessionsControl ?? this.mAllIndividualSessions.length;
  }

  getValues($event: MatSelectChange) {
    this.selectedSubmit = $event.value
    console.log(this.selectedSubmit)

  }

  updateCentre(res: { centreName: string, centreCode: string }) {
    this.selectedCentre = {
      ...this.selectedCentre,
      centreName: res.centreName,
      centreCode: res.centreCode
    };
  }

  openGallery() {
    const dialogRef = this.matDialog.open(PhotoGalleryComponent, {
        height: '90%',
        width: 'auto',
        data: {
          type: 'Counselling',
          path: `${this.env.documents}/Counselling/groupSessions`,
          startDate: this.mStartDate,
          endData: this.mEndDate,
          centreCode: this.selectedCentre.centreCode
        }
      }
    );
    dialogRef.afterClosed().subscribe(res => {
      // alert('Image Selected: '+res.length)
      this.selectedGalleryImages = res
    })
  }

  /**
   * Handles report type selection and sets date range based on financial year
   * @param {MatSelectChange} $event - Material select change event containing selected report type
   * @description Sets start and end dates based on selected report type:
   * - Monthly: Current month
   * - Quarters (1-4): 3 month periods starting from April
   * - Half Years: 6 month periods starting from April
   * - Full Years: April to March of specified year range
   */
  onReportTypeSelect($event: MatSelectChange): void {
    // const reportTypes = ["Monthly", "Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4", "1st Half", "Second Half", "2024-2025", "2025-2026"];
    this.reportType = $event.value;

    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    switch(this.reportType) {
      case "Monthly":
        this.mStartDate = new Date(currentYear, currentMonth, 1);
        this.mEndDate = new Date(currentYear, currentMonth + 1, 0);
        break;

      case "Quarter 1":
        this.mStartDate = new Date(currentYear, 3, 1); // April 1st
        this.mEndDate = new Date(currentYear, 5, 30); // June 30th
        break;

      case "Quarter 2":
        this.mStartDate = new Date(currentYear, 6, 1); // July 1st
        this.mEndDate = new Date(currentYear, 8, 30); // September 30th
        break;

      case "Quarter 3":
        this.mStartDate = new Date(currentYear, 9, 1); // October 1st
        this.mEndDate = new Date(currentYear, 11, 31); // December 31st
        break;

      case "Quarter 4":
        this.mStartDate = new Date(currentYear + 1, 0, 1); // January 1st
        this.mEndDate = new Date(currentYear + 1, 2, 31); // March 31st
        break;

      case "First Half":
        this.mStartDate = new Date(currentYear, 3, 1); // April 1st
        this.mEndDate = new Date(currentYear, 8, 30); // September 30th
        break;

      case "Second Half":
        this.mStartDate = new Date(currentYear, 9, 1); // October 1st
        this.mEndDate = new Date(currentYear + 1, 2, 31); // March 31st
        break;

      case "2024-2025":
        this.mStartDate = new Date(2024, 3, 1); // April 1st 2024
        this.mEndDate = new Date(2025, 2, 31); // March 31st 2025
        break;

      case "2025-2026":
        this.mStartDate = new Date(2025, 3, 1); // April 1st 2025
        this.mEndDate = new Date(2026, 2, 31); // March 31st 2026
        break;
    }
  }

  /**
   * Open counselling photo gallery dialog for selecting images from session documents
   */
  openPhotoGallery(): void {
    if (!this.selectedCentre || !this.mStartDate || !this.mEndDate) {
      this.mSnackbar.open('Please select a centre and date range first', '', { duration: 3000 });
      return;
    }

    import('../../../counseling/counselling-photo-gallery/counselling-photo-gallery.component').then(m => {
      const dialogRef = this.matDialog.open(m.CounsellingPhotoGalleryComponent, {
        width: '90vw',
        maxWidth: '1400px',
        height: '90vh',
        data: {
          centreCode: this.selectedCentre?.centreCode || '',
          sessionType: 'individual',
          startDate: this.mStartDate,
          endDate: this.mEndDate
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && Array.isArray(result)) {
          this.galleryImages = [...this.galleryImages, ...result];
          this.mSnackbar.open(`${result.length} image(s) added to gallery`, '', { duration: 3000 });
        }
      });
    });
  }

  async removeImageFromGallery(index: number): Promise<void> {
    if (index < 0 || index >= this.galleryImages.length) return;
    this.galleryImages.splice(index, 1);
    if (this.mId) {
      try {
        await this.mFirestore.collection(this.env.counsellingImpactReport).doc(this.mId)
          .update({ galleryImages: this.galleryImages });
      } catch (e) {
        console.error('Failed to persist gallery removal', e);
      }
    }
    this.mSnackbar.open('Image removed', '', { duration: 2000 });
  }

  async clearGallery(): Promise<void> {
    this.galleryImages = [];
    if (this.mId) {
      try {
        await this.mFirestore.collection(this.env.counsellingImpactReport).doc(this.mId)
          .update({ galleryImages: [] });
      } catch (e) {
        console.error('Failed to persist gallery clear', e);
      }
    }
    this.mSnackbar.open('Gallery cleared', '', { duration: 2000 });
  }

  openImageInNewTab(url: string): void {
    window.open(url, '_blank');
  }
}
